import React from 'react'
import ReactDOM from 'react-dom'

import Root from './root'

export default function render({ data }) {
  ReactDOM.render(<Root data={data} />, document.getElementById('root'))
}

if (process.env.NODE_ENV === 'development') {
  const data = {
    user: {
      name: 'João de Silva',
      company: 'Hi Platform',
    },
    mobile: false,
  }
  render({ data })
}



// WEBPACK FOOTER //
// ./src/index.js